var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 617,
    viewBox: "0 0 560 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_29)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_19_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.057 22.2247C438.852 34.0177 541.965 171.35 528.223 328.427C514.48 485.505 382.847 605.311 248.052 593.518",
    stroke: "url(#paint0_radial_19_29)",
    strokeOpacity: 0.9,
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.057 22.2247C438.852 34.0177 541.965 171.35 528.223 328.427C514.48 485.505 382.847 605.311 248.052 593.518",
    stroke: "url(#paint1_radial_19_29)",
    strokeOpacity: 0.9,
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.057 22.2247C438.852 34.0177 541.965 171.35 528.223 328.427C514.48 485.505 382.847 605.311 248.052 593.518",
    stroke: "url(#paint2_radial_19_29)",
    strokeOpacity: 0.9,
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.057 22.2247C438.852 34.0177 541.965 171.35 528.223 328.427C514.48 485.505 382.847 605.311 248.052 593.518",
    stroke: "url(#paint3_radial_19_29)",
    strokeOpacity: 0.9,
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.057 22.2247C438.852 34.0177 541.965 171.35 528.223 328.427C514.48 485.505 382.847 605.311 248.052 593.518",
    stroke: "url(#paint4_radial_19_29)",
    strokeOpacity: 0.9,
    strokeWidth: 14
  })), /*#__PURE__*/React.createElement("path", {
    d: "M520.004 327.708C533.738 170.731 435.67 33.9903 301.047 22.2123C166.421 10.4341 40.8578 130.625 27.1244 287.598C13.3907 444.575 111.459 581.316 246.082 593.094C380.708 604.872 506.271 484.682 520.004 327.708Z",
    fill: "url(#paint5_linear_19_29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.004 327.708C533.738 170.731 435.67 33.9903 301.047 22.2123C166.421 10.4341 40.8578 130.625 27.1244 287.598C13.3907 444.575 111.459 581.316 246.082 593.094C380.708 604.872 506.271 484.682 520.004 327.708Z",
    stroke: "url(#paint6_radial_19_29)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.004 327.708C533.738 170.731 435.67 33.9903 301.047 22.2123C166.421 10.4341 40.8578 130.625 27.1244 287.598C13.3907 444.575 111.459 581.316 246.082 593.094C380.708 604.872 506.271 484.682 520.004 327.708Z",
    stroke: "url(#paint7_linear_19_29)",
    strokeOpacity: 0.05,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_19_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.907 324.661C507.243 183.656 419.155 60.9033 298.324 50.332C177.487 39.7601 61.4642 150.382 49.1286 291.379C36.7923 432.383 124.881 555.136 245.711 565.708C366.549 576.28 482.571 465.657 494.907 324.661Z",
    stroke: "url(#paint8_linear_19_29)",
    strokeOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.907 324.661C507.243 183.656 419.155 60.9033 298.324 50.332C177.487 39.7601 61.4642 150.382 49.1286 291.379C36.7923 432.383 124.881 555.136 245.711 565.708C366.549 576.28 482.571 465.657 494.907 324.661Z",
    stroke: "url(#paint9_linear_19_29)",
    strokeOpacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.203 128.463L356.7 321.201L252.349 312.071L177.235 301.484L279.203 128.463Z",
    fill: "#9C7F47"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_19_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.046 125.525L360.208 321.257L252.619 311.844L252.876 311.866L280.046 125.525Z",
    fill: "#FFFEA1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.203 128.463L356.7 321.201L252.349 312.071L252.598 312.093L279.203 128.463Z",
    fill: "#FFFEA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.519 370.669L177.257 301.235L252.707 310.848L356.722 320.951L259.519 370.669Z",
    fill: "#CFAD63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.519 370.669L252.707 310.848L252.707 310.848L356.722 320.951L259.519 370.669Z",
    fill: "#D6B163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.312 391.769L170.528 316.396L246.817 486.231L263.312 391.769Z",
    fill: "#FBD647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.697 394.343L172.263 321.404L244.618 481.331L248.697 394.343Z",
    fill: "#D0AE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.809 395.55L358.185 338.646L244.723 485.818L248.809 395.55Z",
    fill: "#785015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.013 394.371L350.375 343.01L244.898 481.356L249.013 394.371Z",
    fill: "#4F4021"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_29",
    x: 20.5913,
    y: 15.2513,
    width: 520.858,
    height: 601.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_19_29",
    x: 212.442,
    y: -19.7487,
    width: 359.007,
    height: 656.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_19_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_19_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_19_29",
    x: 43.4762,
    y: 45.1324,
    width: 457.083,
    height: 525.775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.316667 0 0 0 0 0.316667 0 0 0 0 0.316667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_19_29"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_19_29",
    result: "effect2_innerShadow_19_29"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0 0.270833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_19_29",
    result: "effect3_innerShadow_19_29"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_19_29",
    x: 252.619,
    y: 125.525,
    width: 107.589,
    height: 195.731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.756863 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_19_29"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(565.99 212.277) rotate(131.521) scale(115.102 51.3348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302247,
    stopColor: "#721A31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#721A31",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(602.609 464.93) rotate(-132.954) scale(288.175 128.524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(466.773 589.063) rotate(-89.7802) scale(144.001 64.2234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7070",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(609.987 437.97) rotate(-138.444) scale(219.103 188.948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00401228,
    stopColor: "#311288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#6EF2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#F3F34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFFFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.579 318.766) rotate(-79.1304) scale(268.91 119.932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19_29",
    x1: 521.041,
    y1: 417.676,
    x2: -110.459,
    y2: 201.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459707,
    stopColor: "#363636",
    stopOpacity: 0.971584
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827067,
    stopColor: "#0A0A0A",
    stopOpacity: 0.995031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_19_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-68.9106 114.57) rotate(30.9442) scale(371.433 320.312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19_29",
    x1: 245.671,
    y1: 305.213,
    x2: 812.03,
    y2: 107.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606261"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19_29",
    x1: -195.808,
    y1: 538.122,
    x2: 417.774,
    y2: 403.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58CBC2",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19_29",
    x1: 636.583,
    y1: 271.655,
    x2: 248.819,
    y2: 342.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D3F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    stopOpacity: 0.33
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlogo);
export default __webpack_public_path__ + "static/media/Mlogo.cc491adeb87677f3eb8b380b93e6239a.svg";
export { ForwardRef as ReactComponent };